import { useState, useEffect } from 'react';
import { Clock, ArrowRight } from '@phosphor-icons/react';
import { RecentSearchesManager } from '../../utils/recentSearchesManager';
import { useTranslation } from 'react-i18next';

// Recent Searches Component
export const RecentSearches = ({ onSearchSelect, recentSearches: propRecentSearches, onClear }) => {
  const { t } = useTranslation();
  const [recentSearches, setRecentSearches] = useState([]);

  useEffect(() => {
    if (propRecentSearches) {
      setRecentSearches(propRecentSearches);
    } else {
      setRecentSearches(RecentSearchesManager.getRecentSearches());
    }
  }, [propRecentSearches]);

  const handleClearAll = () => {
    RecentSearchesManager.clearRecentSearches();
    setRecentSearches([]);
    // Notify parent component that searches were cleared
    if (onClear) {
      onClear();
    }
  };

  return (
    <div style={{ width: '100%' }}>
      {/* Section Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '16px',
        paddingBottom: '12px',
        borderBottom: '1px solid #f0f0f0'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          fontSize: '16px',
          fontWeight: '600',
          color: '#4B164C'
        }}>
          <Clock size={18} />
          <span>{t('recent_searches')}</span>
        </div>
        {recentSearches.length > 0 && (
          <button
            onClick={handleClearAll}
            style={{
              background: 'none',
              border: 'none',
              color: '#888',
              fontSize: '14px',
              fontWeight: '500',
              cursor: 'pointer',
              padding: '4px 8px',
              borderRadius: '6px',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={e => {
              e.currentTarget.style.backgroundColor = '#f8f6fa';
              e.currentTarget.style.color = '#4B164C';
            }}
            onMouseOut={e => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#888';
            }}
          >
            {t('clear')}
          </button>
        )}
      </div>

      {/* Recent Searches List */}
      {recentSearches.length > 0 ? (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px'
        }}>
          {recentSearches.map((search, index) => (
            <button
              key={index}
              onClick={() => onSearchSelect(search)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                background: 'transparent',
                border: 'none',
                padding: '12px',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                textAlign: 'left',
                width: '100%'
              }}
              onMouseOver={e => {
                e.currentTarget.style.backgroundColor = '#f8f6fa';
                e.currentTarget.style.borderColor = '#4B164C';
              }}
              onMouseOut={e => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.borderColor = 'transparent';
              }}
            >
              <Clock size={16} color="#888" />
              <span style={{
                flex: 1,
                fontSize: '14px',
                color: '#4B164C',
                fontWeight: '500',
                textAlign: 'left'
              }}>
                {search}
              </span>
              <ArrowRight size={14} color="#888" />
            </button>
          ))}
        </div>
      ) : (
        <div style={{
          color: '#888',
          fontSize: '14px',
          textAlign: 'center',
          padding: '24px 0',
          fontStyle: 'italic'
        }}>
          {t('no_recent_searches')}
        </div>
      )}
    </div>
  );
}; 